/**
 * 司机端 DidiJSBridge 封装
 * @author xuxiaoyan
 */

import { isAndroid, isIOS, invokeInTurn } from '../util'
import { driverConfig } from '../config'
import { bridgeReady } from '../core/bridge'

let DDBridgeDriver = {}

const defaultFn = function () {}

function call (method, param = {}, callback = defaultFn) {
  invokeInTurn(_call, arguments)
}

function _call (method, param = {}, callback = defaultFn) {
  setTimeout(() => { // hack
    bridgeReady(bridge => {
      bridge.callHandler(method, param, data => {
        if (typeof data == 'string') {
          data = JSON.parse(data)
        }
        callback(data)
      })
    })
  }, 0)
}

/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function driverBridgeFn(name, conf, args) {
  return function (param = {}, callback = defaultFn) {
    if (arguments.length === 1 && typeof param === 'function') {
      callback = param
      param = {}
    }

    let method = conf ? conf.fn : name,
        prepare = conf ? conf.prepare : null

    // 是否支持该方法判断
    // 暂时缺省

    if (prepare && typeof prepare === 'function') {
      call.apply(null, prepare.apply(null, args))
    } else if (name) {
      call(method, param, callback)
    }

  }
}

/**
 * 司机端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initDriverBaseCall(DDBridge) {
  DDBridge.call = function (method, param = {}, callback = defaultFn) {

    let conf = driverConfig[method],
        args = Array.prototype.slice.call(arguments, 0),
        bridgeFn = driverBridgeFn(method, conf, args)

    if ((!callback || callback === defaultFn) && typeof param === 'function') {
      callback = param
      param = {}
    }

    return bridgeFn(param, callback)
  }
}

initDriverBaseCall(DDBridgeDriver)

export { DDBridgeDriver }



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgedriver/index.js